"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const with_html_1 = tslib_1.__importDefault(require("react-markdown/with-html"));
const react_router_dom_1 = require("react-router-dom");
const loadMarkdownWithMeta_1 = require("./loadMarkdownWithMeta");
const OsmosysHelpPage_1 = require("./OsmosysHelpPage");
exports.OsmosysHelpMarkdownPage = props => {
    const [meta, content] = loadMarkdownWithMeta_1.loadMarkdownWithMeta(props.md);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OsmosysHelpPage_1.OsmosysHelpPage, { meta: meta },
            react_1.default.createElement(with_html_1.default, { source: content, escapeHtml: false, linkTarget: (url) => {
                    return url.startsWith('/') ||
                        url.startsWith('.') ||
                        url.includes('osmosys') ||
                        url.includes('127.0.0.0:9000')
                        ? undefined
                        : '_blank';
                }, renderers: {
                    // eslint-disable-next-line react/display-name
                    link: linkProps => {
                        const { href } = linkProps, remainingLinkProps = tslib_1.__rest(linkProps, ["href"]);
                        if (href &&
                            (href.toLowerCase().startsWith('http') ||
                                href.toLowerCase().startsWith('mailto'))) {
                            return react_1.default.createElement("a", Object.assign({ href: href }, remainingLinkProps));
                        }
                        return react_1.default.createElement(react_router_dom_1.Link, Object.assign({ to: href || '/help' }, remainingLinkProps));
                    },
                } }))));
};
exports.default = exports.OsmosysHelpMarkdownPage;
//# sourceMappingURL=OsmosysHelpMarkdownPage.js.map